import React from 'react';

// ============================================================
// OverviewPage — Session 1 (Phase 2 shell) placeholder.
// Full implementation lands in a later session; this file exists so
// AdminShell's page router has something to render for its slug and
// the shell can be verified end-to-end before any real data is wired.
//
// Firestore cost when this placeholder mounts: ZERO reads/writes.
// ============================================================

export default function OverviewPage() {
  return (
    <div className="sa-page-placeholder">
      <div className="sa-page-placeholder-icon">🛠️</div>
      <div className="sa-page-placeholder-title">Coming in a future session</div>
      <div className="sa-page-placeholder-text">
        KPI cards, recent activity feed, and business overview will land here.
      </div>
    </div>
  );
}
